/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import { useEffect, useState } from "react";
import http from "utilities/http";
import Product from "components/shop/product";
import { https } from "utilities/http";
import {getCookie} from "framework/libs/cookie";
import {TOKEN_SHOP} from "framework/store/constants";
import {isArray, isEmpty} from "lodash";
import {Loader} from "../../loader";
import SeeMore from "../../seeMore";
export default function HoSo({ }) {
    const perPage = 8;
    const [productList, setProductList] = useState([]);
    const [wishListAll, setWishListAll] = useState([]);
    const [onDeleteWishList, setOnDeleteWishList] = useState(false);
    const [page,setPage] = useState([perPage,0]);
    const [currentPage,setCurrentPage] = useState(1);
    const [loading,setLoading] = useState(false);

    const fetchItems = async () => {
        const res = await http('/rest/V1/wishlist/items', { size: perPage, page : 1 }, { token: 'Bearer ' + getCookie(TOKEN_SHOP) });
        setProductList(res?.items || []);
        setPage([perPage,res?.total_count ]);
    };
    const fetchAllItems = async () => {
        const res = await http('/rest/V1/wishlist/allItems', {}, {token: 'Bearer ' + getCookie(TOKEN_SHOP)});
        setWishListAll(res);
    };

    useEffect(() => {
        fetchItems();
        fetchAllItems();
    }, []);
    useEffect(() => {
        if (onDeleteWishList){
            const fetchItem = async () => {
                setLoading(true);
                const res = await http('/rest/V1/wishlist/items', { size: perPage*currentPage , page : 1 }, { token: 'Bearer ' + getCookie(TOKEN_SHOP) });
                setProductList(res?.items || []);
                setPage([perPage,res?.total_count ]);
                setLoading(false);
            };
            fetchItem();
            fetchAllItems();
            setOnDeleteWishList(false);
        }
    }, [onDeleteWishList]);

    const genProduct = productList.map((item, index) => {
        return <li key={index}><Product item={item} setOnDeleteWishList={setOnDeleteWishList} ></Product></li>;
    });
    useEffect(()=>{
        const fetchMore = async () => {
            setLoading(true);
            const res = await http('/rest/V1/wishlist/items', { size: perPage, page : currentPage }, { token: 'Bearer ' + getCookie(TOKEN_SHOP) });
            setProductList(productList.concat(res?.items) );
            setLoading(false);
        };
        fetchMore();
    },[currentPage]);
    return (
        <>
            <div className="lstPro-col3 lstPro-col3--16 ">
                <ul>
                    {genProduct}
                </ul>
                <Loader loading={loading}/>
                <SeeMore page={page} currentPage={currentPage} setCurrentPage={setCurrentPage}/>
            </div>
        </>
    );
}